import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    kontakt: [
      {
        type: "Telefon",
        value: "0331 70403094"
      },
      {
        type: "Fax",
        value: "0331 70403096"
      }
    ],
    oeffnungszeiten: [
      {
        tag: "Montag",
        zeit: "08:00 - 13:00"
      },
      {
        tag: "Dienstag",
        zeit: "08:00 - 13:00 \n 15:00 - 18:00"
      },
      // {
      //   tag: "",
      //   zeit: 
      // },
      {
        tag: "Mittwoch",
        zeit: "08:00 - 13:00",
        sonstiges: "nach Vereinbarung"
      },
      {
        tag: "Donnerstag",
        zeit: "10:00 - 13:00 \n 15:00 - 18:00"
      },
      // {
      //   tag: "",
      //   zeit: "15:00 - 18:00"
      // },
      {
        tag: "Freitag",
        zeit: "",
        sonstiges: "nach Vereinbarung"
      }
    ],
    addresse: 'Rudolf-Breitscheid-Straße 22 <br> 14482 Potsdam',
    aktuelles: '',
  },
  mutations: {
    FETCH_AKTUELLES(state, aktuelles) {
      state.aktuelles = aktuelles
    }
  },
  actions: {
    fetchAktuelles({commit}) {
      return axios.get('https://71elxha1fe.execute-api.eu-central-1.amazonaws.com/default/drf-get-data')
      .then(res=>commit("FETCH_AKTUELLES", res.data.aktuelles))
      .catch(err=>console.error(err))
    }
  },
  getters: {
    kontakt(state) {
      return state.kontakt
    },
    oeffnungszeiten(state) {
      return state.oeffnungszeiten
    },
    addresse(state) {
      return state.addresse
    },
    aktuelles (state) {
      return state.aktuelles
    }
  }
});
